import React from 'react'
import { Route, Routes, Navigate } from 'react-router-dom';
import PropTypes from 'prop-types';
import loadable from '@loadable/component'
import { Loader } from '../../../../common/components';

const ListRolesPage = loadable(() => import('./ListRolesPage'), {
    fallback: <Loader/>,
});
const AddRolePage = loadable(() => import('./AddRolePage'), {
    fallback: <Loader/>,
});
const EditRolePage = loadable(() => import('./EditRolePageNew'), {
    fallback: <Loader/>,
});
const RolePermissionPage = loadable(() => import('../Permission/AssignPermission'), {
    fallback: <Loader/>,
});
const RoleRoutes = ({ t,alert }) => {
    return (
        <Routes>
            <Route index exact path="/list" element={<ListRolesPage t={t} alert={alert} />} />
            <Route exact path="/add" element={<AddRolePage t={t} alert={alert} />} />
            <Route exact path="/edit/:role_id" element={<EditRolePage t={t} alert={alert} />} />
            <Route exact path="/permission/:role_id" element={<RolePermissionPage t={t} alert={alert} />} />
            <Route path="*" element={<Navigate replace to="/404" />} />
        </Routes>
    )
}
RoleRoutes.propTypes = {
    t: PropTypes.func
};
export default RoleRoutes;
